import { Icon, Menu } from "semantic-ui-react";
import GuestHouseListTab from "./GuestHouseListTab";
import RoomsTab from "./RoomsTab";
import RoomTypesTab from "./RoomTypesTab";
import AdminUsersTab from "./AdminUsersTab";
import PaymentResponsibilityTab from "./PaymentResponsibilityTab";
import AdvanceBookingLimitsTab from "./AdvanceBookingLimitsTab";
import BookingSettingsTab from "./BookingSettingsTab";
import ReportsTab from "./ReportsTab";
import BillingSettingsTab from "./billing/BillingSettingsTab";
import { useAuth } from "../../context/AuthContext";
import { hasCapability } from "../../utils/capabilities";

export default function GuestHouseTab({
  rooms,
  guestHouses,
  roomTypes,
  floorPriorities,
  onAddGuestHouse,
  onUpdateGuestHouse,
  onDeleteGuestHouse,
  onUpdateGuestHouseBookingSettings,
  onAddRoom,
  onUpdateRoom,
  onDeleteRoom,
  onAddRoomType,
  onUpdateRoomType,
  onDeleteRoomType,
  onAddFloorPriority,
  onUpdateFloorPriority,
  onDeleteFloorPriority,
  paymentResponsibilityOptions,
  onAddPaymentResponsibilityOption,
  onUpdatePaymentResponsibilityOption,
  onDeletePaymentResponsibilityOption,
  advanceBookingLimits,
  onUpdateAdvanceBookingLimit,
  subTab,
  onSubTabChange,
  isSuperAdmin,
}) {
  const { currentUser } = useAuth();
  const canSeeBilling = hasCapability(currentUser, "catalog.view");
  const subTabs = [
    ...(isSuperAdmin
      ? [
          { key: "guest-house", label: "Guest House", icon: "building" },
          { key: "admin-users", label: "Guest House Admins", icon: "users" },
          { key: "payment-responsibility", label: "Payment Responsibility", icon: "credit card outline" },
          { key: "advance-booking-limits", label: "Advance Booking Limits", icon: "calendar outline" },
        ]
      : []),
    { key: "room-types", label: "Room Types", icon: "th list" },
    { key: "rooms", label: "Room Management", icon: "building outline" },
    { key: "booking-settings", label: "Booking Settings", icon: "clock outline" },
    ...(canSeeBilling ? [{ key: "billing", label: "Billing", icon: "rupee sign" }] : []),
    { key: "reports", label: "Reports", icon: "file excel outline" },
  ];

  return (
    <div>
      <Menu pointing secondary>
        {subTabs.map((t) => (
          <Menu.Item
            key={t.key}
            name={t.key}
            active={subTab === t.key}
            onClick={() => onSubTabChange(t.key)}
          >
            <Icon name={t.icon} />
            {t.label}
          </Menu.Item>
        ))}
      </Menu>

      {subTab === "guest-house" && isSuperAdmin && (
        <GuestHouseListTab
          guestHouses={guestHouses}
          onAdd={onAddGuestHouse}
          onUpdate={onUpdateGuestHouse}
          onDelete={onDeleteGuestHouse}
        />
      )}
      {subTab === "reports" && <ReportsTab />}
      {subTab === "billing" && canSeeBilling && <BillingSettingsTab guestHouses={guestHouses} />}
      {subTab === "rooms" && (
        <RoomsTab
          rooms={rooms}
          guestHouses={guestHouses}
          roomTypes={roomTypes}
          onAdd={onAddRoom}
          onUpdate={onUpdateRoom}
          onDelete={onDeleteRoom}
        />
      )}
      {subTab === "room-types" && (
        <RoomTypesTab
          guestHouses={guestHouses}
          roomTypes={roomTypes}
          onAdd={onAddRoomType}
          onUpdate={onUpdateRoomType}
          onDelete={onDeleteRoomType}
        />
      )}
      {subTab === "booking-settings" && (
        <BookingSettingsTab
          guestHouses={guestHouses}
          rooms={rooms}
          floorPriorities={floorPriorities}
          onSave={onUpdateGuestHouseBookingSettings}
          onAddFloorPriority={onAddFloorPriority}
          onUpdateFloorPriority={onUpdateFloorPriority}
          onDeleteFloorPriority={onDeleteFloorPriority}
        />
      )}
      {subTab === "admin-users" && isSuperAdmin && (
        <AdminUsersTab guestHouses={guestHouses} />
      )}
      {subTab === "payment-responsibility" && isSuperAdmin && (
        <PaymentResponsibilityTab
          options={paymentResponsibilityOptions}
          onAdd={onAddPaymentResponsibilityOption}
          onUpdate={onUpdatePaymentResponsibilityOption}
          onDelete={onDeletePaymentResponsibilityOption}
        />
      )}
      {subTab === "advance-booking-limits" && isSuperAdmin && (
        <AdvanceBookingLimitsTab
          limits={advanceBookingLimits}
          onUpdate={onUpdateAdvanceBookingLimit}
        />
      )}
    </div>
  );
}
